/* eslint-disable import/no-unused-modules */

import { FleetApi } from 'api';
import { getApiActionCreator } from 'helpers/actionHelper';
import { filterActionTypes } from './constants';
import { apiCallStatus } from 'helpers/constants';

const getFleetAssetGroup = getApiActionCreator(filterActionTypes.GET_FLEET_ASSET_GROUP);
const getFleetData = getApiActionCreator(filterActionTypes.GET_FLEET_DATA);

const setFleetLoadingAction = (data) => ({
    type: filterActionTypes.SET_FLEET_LOADING,
    data
});

export const setSelectedFleetAction = (data) => ({
    type: filterActionTypes.SET_SELECTED_FLEET,
    data
});

export const setFleetDashboardInitialLoadAction = (data) => ({
    type: filterActionTypes.SET_INITIAL_LOAD_DASHBOARD,
    data
});

export const setDashboardRefreshAnalytics = (flag) => ({
    type: filterActionTypes.SET_DASHBOARD_REFRESH_ANALYTICS,
    data: !!flag
});

export const setRefreshFleetCondition = () => ({
    type: filterActionTypes.REFRESH_FLEET_CONDITION
});

export const setRefreshFleetAll = () => ({
    type: filterActionTypes.REFRESH_FLEET_ALL
});

export const setDashboardRefreshOrigin = (data) => ({
    type: filterActionTypes.SET_DASHBOARD_REFRESH_ORIGIN,
    data
});

export const setLastUpdatedTimestamp = (data) => ({
    type: filterActionTypes.SET_LAST_UPDATED_TIMESTAMP,
    data
});

/**
 * Fetches the list of fleet asset groups.
 * Refactored to use async/await for better readability.
 */
export const getFleetAssetGroupAction = (payload) => async (dispatch) => {
    dispatch(getFleetAssetGroup(apiCallStatus.LOADING));
    try {
        const data = await FleetApi.getFleetAssetGroup(payload);
        // The `|| []` handles cases where the API returns null or undefined data.
        dispatch(getFleetAssetGroup(apiCallStatus.SUCCESS, data || []));
    } catch (err) {
        dispatch(getFleetAssetGroup(apiCallStatus.ERROR, [], err));
    }
};

/**
 * Fetches detailed analytics for a single fleet.
 * Refactored to use async/await and corrected error handling logic.
 */
export const getFleetDataAction = (payload) => async (dispatch, getState) => {
    dispatch(setDashboardRefreshOrigin(null));
    const fleetId = payload?.assetGroupIds[0];
    if (!fleetId) { return; } // Do nothing if there's no ID

    dispatch(setFleetLoadingAction({ [fleetId]: apiCallStatus.LOADING }));

    try {
        const data = await FleetApi.getFleetAnalyticsAggregated('Assets', payload);

        if (data) {
            dispatch(getFleetData(apiCallStatus.SUCCESS, { ...data, assetGroupId: payload?.assetGroupIds }));
            dispatch(setFleetLoadingAction({ [fleetId]: apiCallStatus.SUCCESS }));
        } else {
            // If no data is returned, treat it as an empty success state but flag the loading as an error.
            dispatch(getFleetData(apiCallStatus.SUCCESS, []));
            dispatch(setFleetLoadingAction({ [fleetId]: apiCallStatus.ERROR }));
        }
    } catch (err) {
        // Ensure both the data action and loading status are set to ERROR on failure.
        dispatch(getFleetData(apiCallStatus.ERROR, [], err));
        dispatch(setFleetLoadingAction({ [fleetId]: apiCallStatus.ERROR }));
    }

    // After each fleet finishes, check if all fleets have finished to drop refresh flag
    try {
        const state = getState();
        const { assetGroups, fleetLoading, dashboardRefreshAnalytics } = state.fleetsDashboard || {};
        const groups = assetGroups?.data || [];
        if (dashboardRefreshAnalytics && groups.length > 0) {
            const allFinished = groups.every(g => {
                const status = fleetLoading?.[g?.id];
                return status === apiCallStatus.SUCCESS || status === apiCallStatus.ERROR;
            });
            if (allFinished) {
                dispatch(setDashboardRefreshAnalytics(false));
            }
        }
    } catch (_) { /* no-op */ }
};
